// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import '@/config'
import router from './router'
import App from './components/App/App.vue'
import Vuex from 'vuex'
import VeeValidate from 'vee-validate'
import 'vuetify/src/stylus/app.styl'
import store from './store/index'
import Notifications from 'vue-notification'
import VueCharts from 'vue-chartjs'
import VueBarcodeScanner from 'vue-barcode-scanner'
import '@/bootstrap'
import ConfirmPlugin from '@/components/ConfirmDialog'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import momentTimezone from 'moment-timezone'
import { sync } from 'vuex-router-sync'
import wrapper from '@/layouts/Wrapper/Wrapper'
import wrapperWithTabs from '@/layouts/Wrapper/WrapperWithTabs'
import PlBlockCard from '@/components/PLBlockCard/PLBlockCard'
import DeleteDialog from '@/components/DeleteDialog/DeleteDialog'
import preloader from '@/components/Preloader/Preloader'
import toList from '@/components/Navigation/ToList'
import axios from 'axios'
import PLModal from '@/components/Modal/PLModal'
import TableLayout from '@/layouts/Table/Table'
import SwipeableTable from '@/components/SwipeableTable/SwipeableTable'
import TableHeader from '@/components/TableHeader/TableHeader'
import EmptyMessageBox from '@/components/EmptyMessageBox/EmptyMessageBox'
// import { initMetrika, pageHit } from '@/modules/ya-metrica'
import { isURLApi } from '@/helpers/isURLApi'
// import * as Sentry from '@sentry/vue'
// import { BrowserTracing } from '@sentry/tracing'

Vue.prototype.$config = Vue.config
Vue.prototype.$axios = axios

// Sentry.init({
//   Vue,
//   dsn: 'https://2cd49ac9bfc04cf2b00b1ee96413bc69@logdata.pilkinail.ru//10',
//   integrations: [
//     new BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracePropagationTargets: ['localhost', 'my-site-url.com', /^\//],
//       logErrors: true,
//     }),
//   ],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// })

/**
 * Set yandex metrika visit session params
 */
store.watch(
  state => state.user,
  user => {
    if (!user) {
      return
    }

    if (isImpersonating()) {
      return
    }

    // if (process.env.NODE_ENV === 'production') {
    //   initMetrika({
    //     UserId: user.id ?? null,
    //     brandName: user.company?.brand?.title ?? '<no brand>',
    //     companyType: user.company?.type?.title ?? '<no company type>',
    //   })
    // }
  },
  {
    deep: true,
    immediate: true,
  },
)

Vue.prototype.$axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
Vue.prototype.$axios.defaults.headers.common['X-Locale'] = navigator.language.substring(0, 2)
Vue.prototype.$axios.interceptors.response.use(
  response => Promise.resolve(response),
  error => {
    const status = error.response ? error.response.status : null

    if (status === 401 && isURLApi(error)) {
      localStorage.removeItem('token')
      router.push({ name: 'auth' })
    }

    // Sentry.captureException(error)
    return Promise.reject(error)
  },
)

Vue.component('wrapper', wrapper)
Vue.component('wrapper-with-tabs', wrapperWithTabs)
Vue.component('delete-dialog', DeleteDialog)
Vue.component('preloader', preloader)
Vue.component('to-list', toList)
Vue.component('pl-block-card', PlBlockCard)
Vue.component('pl-modal', PLModal)
Vue.component('table-layout', TableLayout)
Vue.component('swipeable-table', SwipeableTable)
Vue.component('table-header', TableHeader)
Vue.component('empty-message-box', EmptyMessageBox)

// plugins
import transform from './plugins/transform'
import fullName from './plugins/fullName'
import permissions from './plugins/permissions'
import query_builder from './plugins/query_builder'
import format_number from './plugins/format_number'
import format_date from './plugins/format_date'
import get_text from './plugins/get_text'
import generatePassword from './plugins/generatePassword'
import itemsSort from './plugins/itemsSort'
import setLoad from './plugins/setLoad'
import getFormData from './plugins/getFormData'
// import socket from './plugins/socket.io';

Vue.use(transform)
Vue.use(fullName)
Vue.use(permissions)
Vue.use(query_builder)
Vue.use(format_number)
Vue.use(format_date)
Vue.use(get_text)
Vue.use(generatePassword)
Vue.use(setLoad, store)
Vue.use(itemsSort)
Vue.use(getFormData)
// Vue.use(socket);

const options = {
  // you may define your apiKey, lang and version or skip this.
  apiKey: '',
  lang: 'ru_RU',
  version: '2.1',
}
Vue.prototype.$moment = moment
Vue.prototype.$moment.suppressDeprecationWarnings = true
momentDurationFormatSetup(Vue.prototype.$moment)
momentTimezone(Vue.prototype.$moment)
const isProduction = process.env.NODE_ENV === 'production'
sync(store, router)

router.beforeEach((to, from, next) => {
  // pageHit(to)
  next()
})

// import * as Sentry from '@sentry/browser'
// import * as Integrations from '@sentry/integrations'

// Sentry.init({
//   dsn: 'https://2cd49ac9bfc04cf2b00b1ee96413bc69@logdata.pilkinail.ru//10',
//   integrations: [
//     new Integrations.Vue({
//       Vue,
//       attachProps: true,
//     }),
//   ],
// })

import {
  Vuetify,
  VAutocomplete,
  VCombobox,
  VSlider,
  VTextarea,
  VRating,
  VApp,
  VNavigationDrawer,
  // VListItem,
  // VListItemAvatar,
  // VListItemContent,
  // VListItemTitle,
  // VListItemSubtitle,
  // VListItemIcon,
  VMenu,
  VStepper,
  VDatePicker,
  VTimePicker,
  VDialog,
  VDivider,
  VFooter,
  VBadge,
  VRangeSlider,
  VList,
  VBtn,
  VBtnToggle,
  VChip,
  VAvatar,
  VIcon,
  VGrid,
  VCard,
  VTabs,
  VSwitch,
  VToolbar,
  VTextField,
  VForm,
  VDataTable,
  VCheckbox,
  VExpansionPanel,
  VProgressCircular,
  VSelect,
  VRadioGroup,
  transitions,
  VCarousel,
  VImg,
  VSubheader,
  VTooltip,
  VAlert,
  VPagination,
} from 'vuetify'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
Vue.use(Vuex)
Vue.use(VeeValidate)
Vue.use(Notifications)
Vue.use(VueCharts)
Vue.use(Vuetify, {
  components: {
    VApp,
    VAutocomplete,
    VCombobox,
    VSlider,
    VTextarea,
    VRating,
    VNavigationDrawer,
    // VListItem,
    // VListItemAvatar,
    // VListItemContent,
    // VListItemTitle,
    // VListItemSubtitle,
    // VListItemIcon,
    VMenu,
    VStepper,
    VDatePicker,
    VTimePicker,
    VDialog,
    VDivider,
    VFooter,
    VBadge,
    VList,
    VBtn,
    VBtnToggle,
    VChip,
    VAvatar,
    VIcon,
    VGrid,
    VCard,
    VTabs,
    VSwitch,
    VToolbar,
    VTextField,
    VForm,
    VCheckbox,
    VDataTable,
    VProgressCircular,
    VSelect,
    VRadioGroup,
    transitions,
    VCarousel,
    VImg,
    VRangeSlider,
    VTooltip,
    VSubheader,
    VAlert,
    VExpansionPanel,
    VPagination,
  },
  theme: {
    primary: '#36afbb',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    'grey-light': '#bababa',
  },
  iconfont: 'md',
})
Vue.use(TiptapVuetifyPlugin, {
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'md',
})
Vue.use(VueBarcodeScanner, { sensitivity: 80 })
Vue.use(ConfirmPlugin)
import '@/assets/scss/_main.scss'

Vue.config.productionTip = false
Vue.config.performance = !isProduction
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

import VueCurrencyFilter from 'vue-currency-filter'
import { isImpersonating } from '@/helpers/impersonate-utils'

Vue.use(VueCurrencyFilter, {
  symbol: '',
  thousandsSeparator: ' ',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'back',
  symbolSpacing: false,
})

document.addEventListener('wheel', event => {
  if (document.activeElement.type === 'number') {
    document.activeElement.blur()
  }
})
